import { Box3, Sphere, Vector3, Vector3Tuple } from 'three';

import { BBoxDescription } from '../types/bboxes';

import { box3tuple, includeBox3 } from './vectors';

/**
 * Given a bounding box returns the ABSOLUTE coordinates of the bounding bbox, center, size and radius
 * no offset is applied, scale is applied if applyScale is provided !== 1
 * @param bbox
 * @returns
 */
export function detailBbox(bbox: [Vector3Tuple, Vector3Tuple], applyScale = 1) {
  const minMax = [
    new Vector3(...bbox[0]).multiplyScalar(applyScale),
    new Vector3(...bbox[1]).multiplyScalar(applyScale),
  ];
  const bboxDeserialized = new Box3().setFromPoints(minMax);

  const size = new Vector3();
  bboxDeserialized.getSize(size);

  const sphere = new Sphere();
  bboxDeserialized.getBoundingSphere(sphere);

  const center = new Vector3();
  bboxDeserialized.getCenter(center);

  return {
    bbox: bboxDeserialized,
    center,
    size,
    sphere,
  };
}

export function mergeBboxes(bboxes: BBoxDescription[]) {
  const includingBox3 = includeBox3(bboxes.map((b) => b.bbox));
  const resultBbox = detailBbox(box3tuple(includingBox3));
  return resultBbox;
}

export function isValidBBox(bbox: BBoxDescription) {
  return (
    !bbox.size.find((s) => typeof s !== 'number' || !isFinite(s)) &&
    !bbox.bbox.find((b) =>
      b.find((b1) => typeof b1 !== 'number' || !isFinite(b1)),
    )
  );
}
